// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__Eg1zY","rotate":"styles_rotate__LZ2e-","divloading":"styles_divloading__gZDE3"};